import React                   from 'react'
import { withRouter } from "react-router-dom"
import i18n from '../../../i18n'

class AppUsage extends React.Component {
  render() {
    return (
      <div className="support-container small-container" id="e-certificate-container">
        <div className="row no-gutters">
          <div className="col-sm-9 title padl-0">{i18n.t("support.app_usage.title")}</div>
          <div className="col-sm-12 content-body">
            <h3>...</h3>
          </div>
        </div>
        <div className="go-back">
          <button className="btn-link normal" onClick={() => this.props.history.goBack()}>前のページへ戻る</button>
        </div>
      </div>
    )
  }
}

export default withRouter(AppUsage)
